define('models/calendar/text-session/activity-type',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
], function(_, Backbone, U, API) {

    var MActivityType = Backbone.Model.extend({
        idAttribute: '_id',
        urlRoot: API.url("activities/"),
        defaults: {},

        getName: function() {
            return this.get('name');
        },
    });

    // Return the model for the module
    return MActivityType;
});

